export default __webpack_public_path__ + "static/media/stride_logo_loading.36fba485.gif";